module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@2x-3e50b0af4c7a2b19441b8ab41d5530c0.png";